import Footer from './Components/Footer/Footer';
import Navbar from './Components/Navbar/Navbar';
import AboutSection from './Pages/AboutSection/AboutSection';
import AvailableOnSection from './Pages/AvailableOnSection/AvailableOnSection';
import HeroSection from './Pages/HeroSection/HeroSection';
import HowToBuySection from './Pages/HowToBuySection/HowToBuySection';
import SocialSection from './Pages/SocialSection/SocialSection';
import TokenomicsSection from './Pages/TokenomicsSection/TokenomicsSection';

function App() {
  return (
    <div className="flex flex-col text-white bg-black min-h-screen">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <AboutSection />
        <TokenomicsSection />
        <HowToBuySection />
        <AvailableOnSection />
        <SocialSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
